import { render } from "./IdealForm.vue?vue&type=template&id=f232c77c"
import script from "./IdealForm.vue?vue&type=script&lang=js"
export * from "./IdealForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__